import { useEffect, useState } from 'react';
import { WeatherWall } from 'types';

const useGetChartFontSize = (currentWall: WeatherWall | undefined) => {
  const [fontSize, setFontSize] = useState<string | undefined>();
  useEffect(() => {
    const getSize = () => {
      if (!currentWall) return setFontSize(undefined);
      const numberOfColumns = currentWall.columns;
      if (window && window.innerWidth > 1700) {
        if (numberOfColumns > 3) setFontSize('80%');
        else setFontSize(undefined);
      } else if (window && window.innerWidth < 1550) {
        if (numberOfColumns > 2) setFontSize('70%');
        else setFontSize(undefined);
      } else if (window && window.innerWidth < 1000) {
        if (numberOfColumns > 1) setFontSize('70%');
        else setFontSize(undefined);
      } else {
        if (numberOfColumns > 2) setFontSize('80%');
        else if (numberOfColumns > 3) setFontSize('70%');
        else setFontSize(undefined);
      }
    };
    getSize();
    if (window) window.addEventListener('resize', getSize);
    return () => window.removeEventListener('resize', getSize);
  }, [currentWall, currentWall?.columns]);
  return fontSize;
};

export default useGetChartFontSize;
